import React from 'react'
import { oneOfType, string, func, number, bool, arrayOf, object, any } from 'prop-types'
import ReactTimePicker from 'rc-time-picker'
import momentPropTypes from 'react-moment-proptypes'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import Select, { Async } from 'react-select'
import 'react-datepicker/dist/react-datepicker.css'
// import 'react-select/dist/react-select.css'
import 'rc-time-picker/assets/index.css'

import './Fields.scss'

const TextField = props => (
  <div className={`group material__textfield ${props.customClass}`}>
    <input
      className={`${props.error !== '' ? 'error-input' : ''} ${props.value ? 'active' : ''}`}
      type={props.type}
      name={props.name}
      disabled={props.disabled ? 'disabled' : ''}
      onFocus={props.handleOnFieldFocus}
      onBlur={props.handleOnFieldBlur}
      onChange={props.handleOnFieldChange}
      value={props.value ? props.value : ''}
      tabIndex={props.tabIndex} />
    <span className='highlight' />
    <span className='bar' />
    <label htmlFor={props.label}>{props.label}</label>
    {props.error !== '' && <div className='error'>{props.error}</div>}
  </div>
)

TextField.propTypes = {
  type: string.isRequired,
  handleOnFieldFocus: func.isRequired,
  handleOnFieldBlur: func.isRequired,
  handleOnFieldChange: func.isRequired,
  customClass: string,
  value: oneOfType([string, number]).isRequired,
  name: string.isRequired,
  tabIndex: number,
  label: string.isRequired,
  error: string,
  disabled: bool,
}

TextField.defaultProps = {
  customClass: '',
  tabIndex: 0,
  error: '',
  disabled: false,
}

const TextAreaField = props => (
  <div className={`group material__textfield ${props.customClass}`}>
    <h6 className='label' htmlFor={props.label}>{props.label}</h6>
    <textarea
      className={`${props.error !== '' ? 'error-input' : ''} ${props.value ? 'active' : ''}`}
      name={props.name}
      disabled={props.disabled ? 'disabled' : ''}
      onFocus={props.handleOnFieldFocus}
      onBlur={props.handleOnFieldBlur}
      onChange={props.handleOnFieldChange}
      tabIndex={props.tabIndex}>{props.value || ''}</textarea>
    <span className='highlight' />
    <span className='bar' />
    {props.error !== '' && <div className='error'>{props.error}</div>}
  </div>
)

TextAreaField.propTypes = {
  handleOnFieldFocus: func.isRequired,
  handleOnFieldBlur: func.isRequired,
  handleOnFieldChange: func.isRequired,
  customClass: string,
  value: string.isRequired,
  name: string.isRequired,
  tabIndex: number,
  label: string.isRequired,
  error: string,
  disabled: bool,
}

TextAreaField.defaultProps = {
  customClass: '',
  tabIndex: 0,
  error: '',
  disabled: false,
}

const SelectField = props => (
  <div className={`group material__textfield select ${props.customClass}`}>
    <div className='select__wrapping'>
      <select
        value={props.value}
        className={`${props.error !== '' ? 'error-input' : ''} ${props.value ? 'active' : ''}`}
        name={props.name}
        onFocus={props.handleOnFieldFocus}
        onBlur={props.handleOnFieldBlur}
        onChange={props.handleOnFieldChange}
        tabIndex={props.tabIndex} >
        {
          props.defaultLabels !== '' && <option value='0'>{props.defaultLabels}</option>
        }
        {
          props.selectData.map(res => (<option
            key={[`selected-${props.name}-${res.slug || res.id}`]}
            value={res.slug || res.id}>{res.name}</option>))
        }
      </select>
    </div>
    <span className='highlight' />
    <span className='bar' />
    { !props.noLabel && <label htmlFor={props.label}>{props.label}</label> }
    {props.error !== '' && <div className='error'>{props.error}</div>}
  </div>
)

SelectField.propTypes = {
  handleOnFieldChange: func.isRequired,
  value: oneOfType([string, number]).isRequired,
  name: string.isRequired,
  handleOnFieldFocus: func,
  handleOnFieldBlur: func,
  customClass: string,
  tabIndex: number,
  label: string,
  error: string,
  selectData: arrayOf(object),
  defaultLabels: string,
  noLabel: bool,
}

SelectField.defaultProps = {
  customClass: '',
  tabIndex: 0,
  error: '',
  selectData: [],
  noLabel: false,
  handleOnFieldFocus: () => {},
  handleOnFieldBlur: () => {},
  label: '',
  defaultLabels: '',
}

const DatePickerField = props => (
  <div className={`group material__textfield select ${props.customClass}`}>
    <DatePicker
      dateFormat={'YYYY-MM-DD'}
      showYearDropdown
      selected={props.value}
      onChange={props.handleOnFieldChange} />
    <span className='highlight' />
    <span className='bar' />
    <label htmlFor={props.label}>{props.label}</label>
    {props.error !== '' && <div className='error'>{props.error}</div>}
  </div>
)

DatePickerField.propTypes = {
  handleOnFieldChange: func.isRequired,
  customClass: string,
  value: any,
  name: string.isRequired,
  tabIndex: number,
  label: string.isRequired,
  error: string,
  disabled: bool,
}

DatePickerField.defaultProps = {
  customClass: '',
  tabIndex: 0,
  error: '',
  disabled: false,
  value: null,
}

class TypeableSelectField extends React.Component {
  onInputChange = (value, { action }) => {
    if (action === 'input-change') {
      const { handleInputChange, name } = this.props

      handleInputChange(value, name)
    }
  }

  onChange = ({ value }) => {
    const { handleOnFieldChange, name } = this.props

    handleOnFieldChange({ target: { name, value } })
  }

  render() {
    const {
      name, value, selectData = [], customClass, label, error,
      handleOnFieldFocus, handleOnFieldBlur, tabIndex, placeholder, loadOptions,
      isLoading, async,
    } = this.props
    const opts = selectData.map(({ id: cityId, name: cityName }) => ({
      value: cityId,
      label: cityName,
    }))

    const selectProps = {
      name,
      value: opts.find(({ value: optValue }) => (optValue === value)),
      onInputChange: this.onInputChange,
      onChange: this.onChange,
      onBlur: handleOnFieldBlur,
      onFocus: handleOnFieldFocus,
      onSelectResetsInput: false,
      onBlurResetsInput: false,
      options: opts,
      placeholder,
      noOptionsMessage: () => (isLoading && !async ? 'Mencari...' : 'Tidak ada hasil'),
      clearable: false,
      tabIndex,
      className: 'react-select-container',
      classNamePrefix: 'react-select',
    }

    const selectComponent = async ?
      <Async {...selectProps} loadOptions={loadOptions} /> :
      <Select {...selectProps} />

    return (
      <div className={`group material__textfield select typed-select ${customClass}`}>
        {selectComponent}
        <span className='highlight' />
        <span className='bar' />
        <label htmlFor={label}>{label}</label>
        {error !== '' && <div className='error'>{error}</div>}
      </div>
    )
  }
}

TypeableSelectField.propTypes = {
  handleOnFieldChange: func.isRequired,
  handleInputChange: func,
  name: string.isRequired,
  handleOnFieldFocus: func,
  handleOnFieldBlur: func,
  customClass: string,
  tabIndex: number,
  label: string,
  error: string,
  value: oneOfType([string, number]).isRequired,
  placeholder: string,
  selectData: arrayOf(object),
  loadOptions: func,
  async: bool,
}
TypeableSelectField.defaultProps = {
  customClass: '',
  tabIndex: 0,
  error: '',
  selectData: [],
  handleOnFieldFocus: () => {},
  handleOnFieldBlur: () => {},
  handleInputChange: () => {},
  label: '',
  value: '',
  placeholder: '',
  loadOptions: () => {},
  async: false,
}

const TimePicker = ({ label, error, ...rest }) => (
  <div className='group material__textfield'>
    <h6 className='label' htmlFor={label}>{label}</h6>
    <ReactTimePicker {...rest} />
    {error !== '' && <div className='error'>{error}</div>}
  </div>
)

TimePicker.defaultProps = {
  style: { width: 100 },
  showSecond: false,
  value: moment(),
  className: '',
  label: '',
  error: '',
}

TimePicker.propTypes = {
  style: object,
  showSecond: bool,
  value: momentPropTypes,
  className: string,
  label: string,
  error: string,
  onChange: func.isRequired,
}

export {
  TextField,
  SelectField,
  TextAreaField,
  DatePickerField,
  TypeableSelectField,
  TimePicker,
}



// WEBPACK FOOTER //
// ./src/common/Fields/index.js